import { get, post, put } from '@utils/xhr';

class LanguageService {
  async active() {
    try {
      const response = await get({ url: `${process.env.apiPath}/api/language/active` });
      return response;
    } catch (error) {
      return error.response;
    }
  }

  async default(language) {
    try {
      const response = await post({
        url: `${process.env.apiPath}/api/language/default`,
        data: {
          id: language.id,
        },
      });
      return response;
    } catch (error) {
      return error.response;
    }
  }

  async enable(language, enable) {
    try {
      const response = await post({
        url: `${process.env.apiPath}/api/language/enable`,
        data: {
          id: language.id,
          enable,
        },
      });
      return response;
    } catch (error) {
      return error.response;
    }
  }

  async set(language) {
    try {
      const response = await put({
        url: `${process.env.apiPath}/api/language`,
        data: {
          id: language,
        },
      });
      return response;
    } catch (error) {
      return error.response;
    }
  }
}

export const languageService = new LanguageService();
